import pt from 'vee-validate/dist/locale/pt_BR'
import { Validator } from 'vee-validate'

// Localize takes the locale object as the second argument (optional) and merges it.
Validator.localize('pt', pt);

const config = {
	locale: 'pt',
	errorBagName: 'errors', // change if property conflicts
	fieldsBagName: 'fields',
	delay: 0,
	dictionary: null,
	strict: true,
	classes: false,
	classNames: {
		touched: 'touched', // the control has been blurred
		untouched: 'untouched', // the control hasn't been blurred
		valid: 'valid', // model is valid
		invalid: 'invalid', // model is invalid
		pristine: 'pristine', // control has not been interacted with
		dirty: 'dirty' // control has been interacted with
	},
	events: 'blur',
	inject: true,
	validity: false,
	aria: true
  };

export default config



// WEBPACK FOOTER //
// ./src/config/vee-validate.js